export default __webpack_public_path__ + "static/media/DJI_0959.MP4.00_02_17_00.Still001.25991d87.jpg";